module.exports = __webpack_public_path__ + "static/img/Report3DImg1.c200f281.png";